import { gql } from "graphql-tag";
import { useEffect, useRef } from "react";

import { GraphQLAPI, GraphQLObservable } from "@examspark/api";
import { useVolatileCallback } from "@examspark/common-ui";
import { SystemEvent } from "@examspark/types";

export const useSystemEventNotifications = (
  codebaseName: string | undefined,
  callback: (e: SystemEvent) => void,
  enabled?: boolean,
) => {
  const callbackVolatile = useVolatileCallback(callback);

  const subscription = useRef<
    | ReturnType<
        GraphQLObservable<{
          onCreateSystemEvent: SystemEvent;
        }>["subscribe"]
      >
    | null
    | undefined
  >(null);
  useEffect(() => {
    if (!enabled) return;
    if (subscription.current !== null) return;

    GraphQLAPI.subscribe<{ onCreateSystemEvent: SystemEvent }>({
      query: gql`
        subscription OnCreateSystemEvent {
          onCreateSystemEvent {
            type
            codebaseName
            data
            __typename
          }
        }
      `,
      auth: "API_KEY",
    })
      .then((obs) => {
        subscription.current = obs.subscribe({
          next: ({ value }) => {
            const e = value.data?.onCreateSystemEvent;
            if (e == null) return;
            if (
              e.codebaseName != null &&
              codebaseName != null &&
              e.codebaseName !== codebaseName
            ) {
              return;
            }

            callbackVolatile(e);
          },
        });
      })
      .catch((e) => {
        console.error("Failed to subscribe to system events", e);
        // prevent the subscription from trying again.
        subscription.current = undefined;
      });

    return () => {
      if (subscription.current != null) {
        subscription.current.unsubscribe();
      }
    };
  }, [codebaseName, callbackVolatile, enabled]);
};
